/*
 * @Author: your name
 * @Date: 2021-08-09 15:11:52
 * @LastEditTime: 2021-08-17 17:43:17
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /zq/src/page/footer/index.tsx
 */
/* eslint-disable react/jsx-no-target-blank */
import React from "react";
import NameLog from '../../img/name.png'
import './index.css';

export class Foot extends React.Component<{}, {}> {
    render() {
        return <div className='foot'>
            <div className='foot-box'>
                <div>
                    <img src={NameLog} alt="彼岸曼陀罗华" />
                </div>
                <div className='put_on_records'>
                    <p>
                        <img src="https://img.alicdn.com/tfs/TB1..50QpXXXXX7XpXXXXXXXXXX-40-40.png" alt="" style={{width:'16px'}} />
                        <a className='foot-a' href="http://beian.miit.gov.cn/?token=2beb80fd-bc9b-4029-a5ad-042d3e7d9662" target="_blank">京ICP备2021024379号-1</a>
                    </p>
                </div>
            </div>

        </div>
    }
}